import { Pressable, StyleSheet } from "react-native";

import { SvgIcon, palette, spacing } from "@stepapp/ui";

type Props = {
  value: boolean;
  onValueChange: () => void;
};

const RadioButton = ({ value, onValueChange }: Props) => {
  return (
    <Pressable
      onPress={onValueChange}
      style={[
        styles.radioButton,
        value ? styles.radioButtonSelected : styles.radioButtonDeselected,
      ]}
    >
      {value && <SvgIcon color={palette.common.white} name="done" size={spacing.unit * 2.5} />}
    </Pressable>
  );
};

export default RadioButton;

const styles = StyleSheet.create({
  radioButton: {
    alignItems: "center",
    borderRadius: spacing.unit * 2,
    height: spacing.unit * 4,
    justifyContent: "center",
    width: spacing.unit * 4,
  },
  radioButtonDeselected: {
    borderColor: palette.common.gray,
    borderWidth: spacing.border * 2,
  },
  radioButtonSelected: {
    backgroundColor: palette.primary.accent,
  },
});
